<template>
  <div class="security-privacy-container dashboard-main-content py-4 p-3 p-md-5">
    <h2 class="mb-4 text-primary-emphasis">Segurança e Privacidade</h2>

    <p class="text-muted mb-4 description-text">
      Na nossa plataforma, a segurança e a privacidade dos seus dados são nossa maior prioridade. Entenda como protegemos suas informações e quais são os seus direitos.
    </p>

    <div class="card mb-4">
      <div class="card-body">
        <h5 class="card-title text-primary-emphasis mb-3"><i class="fas fa-file-contract me-2"></i>Nossas Políticas</h5>
        <p class="card-text">
          Nossa Política de Privacidade detalha como coletamos, usamos, armazenamos e protegemos suas informações pessoais. Nossos Termos de Uso descrevem as regras para utilização da plataforma e as Regras de Saque explicam as condições de transferência dos valores arrecadados.
        </p>
        <div class="d-flex flex-column flex-md-row gap-2 mt-3">
          <router-link to="/politica-de-privacidade" class="btn btn-outline-secondary btn-sm">
            Ver Política de Privacidade
          </router-link>
          <router-link to="/termos-de-uso" class="btn btn-outline-secondary btn-sm">
            Ver Termos de Uso
          </router-link>
          <router-link to="/termos-de-saque" class="btn btn-outline-secondary btn-sm">
            Ver Regras de Saque
          </router-link>
        </div>
      </div>
    </div>

    <div class="card mb-4">
      <div class="card-body">
        <h5 class="card-title text-primary-emphasis mb-3"><i class="fas fa-shield-alt me-2"></i>Como Protegemos Seus Dados</h5>
        <ul class="list-unstyled">
          <li class="mb-2">
            <i class="fas fa-check-circle text-success me-2"></i>
            <b>Criptografia Forte:</b> Todas as suas informações são transmitidas usando criptografia SSL/TLS, garantindo que seus dados estejam seguros durante a comunicação.
          </li>
          <li class="mb-2">
            <i class="fas fa-check-circle text-success me-2"></i>
            <b>Armazenamento Seguro:</b> Suas senhas são armazenadas com técnicas avançadas de hashing, impossibilitando seu acesso direto.
          </li>
          <li class="mb-2">
            <i class="fas fa-check-circle text-success me-2"></i>
            <b>Parceiros de Pagamento Certificados:</b> Utilizamos parceiros de pagamento líderes de mercado e certificados (como PCI DSS) para processar todas as transações financeiras.
          </li>
          <li>
            <i class="fas fa-check-circle text-success me-2"></i>
            <b>Monitoramento Contínuo:</b> Nossos sistemas são monitorados 24/7 para identificar e mitigar potenciais ameaças de segurança.
          </li>
        </ul>
      </div>
    </div>

    <div class="card mb-4">
      <div class="card-body">
        <h5 class="card-title text-primary-emphasis mb-3"><i class="fas fa-user-lock me-2"></i>Sua Segurança Pessoal</h5>
        <p class="card-text">
          A segurança dos seus dados também depende de você! Siga estas dicas para manter sua conta protegida:
        </p>
        <ul class="list-unstyled">
          <li class="mb-2">
            <i class="fas fa-lightbulb text-warning me-2"></i>
            Crie <b>senhas fortes e únicas</b> para sua conta, utilizando uma combinação de letras, números e símbolos.
          </li>
          <li class="mb-2">
            <i class="fas fa-lightbulb text-warning me-2"></i>
            <b>Nunca compartilhe sua senha</b> com ninguém. Nós nunca a solicitaremos por e-mail ou telefone.
          </li>
          <li class="mb-2">
            <i class="fas fa-lightbulb text-warning me-2"></i>
            Considere ativar a <b>Autenticação de Dois Fatores (2FA)</b>, se disponível, para uma camada extra de segurança.
          </li>
          <li>
            <i class="fas fa-lightbulb text-warning me-2"></i>
            Fique atento(a) a <b>e-mails ou mensagens de phishing</b> que tentam roubar suas informações.
          </li>
        </ul>
      </div>
    </div>

    <div class="card mb-4">
      <div class="card-body">
        <h5 class="card-title text-primary-emphasis mb-3"><i class="fas fa-user-check me-2"></i>Seus Direitos de Privacidade (LGPD)</h5>
        <p class="card-text">
          Conforme a Lei Geral de Proteção de Dados (LGPD), você tem direitos sobre suas informações pessoais:
        </p>
        <ul class="list-unstyled">
          <li class="mb-2">
            <i class="fas fa-info-circle text-info me-2"></i>
            <b>Acesso e Retificação:</b> Você pode solicitar acesso aos seus dados e corrigi-los.
          </li>
          <li class="mb-2">
            <i class="fas fa-eraser text-info me-2"></i>
            <b>Exclusão:</b> Em certas condições, você pode solicitar a exclusão de seus dados.
          </li>
          <li>
            <i class="fas fa-share-alt text-info me-2"></i>
            <b>Portabilidade:</b> Você tem o direito de receber seus dados em um formato estruturado.
          </li>
        </ul>
        <p class="card-text mt-3">Para exercer qualquer um desses direitos ou tirar dúvidas, entre em contato com nosso Encarregado de Dados (DPO) através do e-mail: <b>privacidade@quemimo.com.br</b></p>
      </div>
    </div>

  </div>
</template>

<script setup>
// Não há lógica JavaScript específica necessária para esta página.
</script>

<style scoped>
/* Os estilos CSS permanecem exatamente os mesmos */
.security-privacy-container {
  max-width: 700px;
  width: 100%;
  margin: 0 auto;
  padding: 1rem;
}

@media (min-width: 768px) {
  .security-privacy-container {
    padding: 3rem;
  }
}

.text-primary-emphasis {
  color: #32355d !important;
}

.description-text {
  font-size: 0.95rem;
  line-height: 1.4;
  color: #6c757d; 
  margin-bottom: 1.5rem; 
}

.card {
  border: 1px solid #e0e0e0;
  border-radius: 0.75rem;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.card-title {
  font-weight: 600;
  font-size: 1.25rem;
}

.card-text, .list-unstyled li {
  font-size: 0.95rem;
  line-height: 1.5;
  color: #495057;
}

.list-unstyled {
  padding-left: 0;
}

.list-unstyled li i {
  font-size: 1.1rem;
  width: 25px;
  text-align: center;
}

.btn-outline-secondary {
  border-color: #ced4da;
  color: #6c757d;
}
.btn-outline-secondary:hover {
  background-color: #f8f9fa;
  border-color: #adb5bd;
  color: #495057;
}

.text-success {
  color: #28a745 !important;
}
.text-warning {
  color: #ffc107 !important;
}
.text-info {
  color: #17a2b8 !important;
}

/* Estilos de botão genéricos (repetidos do seu CSS existente para consistência) */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem 1.25rem;
  border-radius: 0.5rem;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  white-space: nowrap;
}
.btn i.me-2 {
  margin-right: 0.5rem;
}
</style>